import usersAxios from './createApi/usersApi';

export const usersApi = {
	getWhatsappOperators: async () => {
		return await usersAxios.get( '/whatsapp' );
	}
};
